export default __webpack_public_path__ + "static/latitude-pay-video@2x-acdfbff93f8fdcc2ee6d703985f8cd3f.png";